(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nized-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const inner = document.getElementById('nz-promo-inner');
  if (!inner) return;

  const restart = () => {
    inner.style.animation = 'none';
    inner.style.webkitAnimation = 'none';
    void inner.offsetWidth;
    inner.style.animation = '';
    inner.style.webkitAnimation = '';
    inner.style.animationPlayState = 'running';
    inner.style.webkitAnimationPlayState = 'running';
  };

  inner.addEventListener('animationend', restart, { passive: true });
  window.addEventListener('pageshow', restart, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') restart();
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
